<div class="testmanager-kpis">
  <app-kpi-card
    [label]="'liveDashboard.testmanager.kpis.passRate' | translate"
    [value]="passRateValue()"
    suffix="%"
    icon="check"
    iconColorVar="--to-green-dot"
    [sparkline]="kpis().passRate.sparkline"
  />
  <app-kpi-card
    [label]="'liveDashboard.testmanager.kpis.activeTestRuns' | translate"
    [value]="kpis().activeTestRuns.value"
    icon="bar_chart"
    iconColorVar="--to-blue-dot"
    [sparkline]="kpis().activeTestRuns.sparkline"
  />
  <app-kpi-card
    [label]="'liveDashboard.testmanager.kpis.openRequirements' | translate"
    [value]="kpis().openRequirements.value"
    icon="folder"
    iconColorVar="--to-brand"
    [sparkline]="kpis().openRequirements.sparkline"
  />
  <app-kpi-card
    [label]="'liveDashboard.testmanager.kpis.failed24h' | translate"
    [value]="kpis().failed24h.value"
    icon="close"
    iconColorVar="--to-chart-failed"
    [sparkline]="kpis().failed24h.sparkline"
  />
</div>
